import { Server } from "./server";
import { ServerConfig } from "./serverConfig";

export class ServiceResponse {
  success: boolean;
  message?: string;
}

export class Service {
  protected static authorizationToken: string = '';
  protected static environment: string = 'dev';
  protected static community: string = '';

  public static setAuthorizationToken(token: string) {
    Service.authorizationToken = token;
  }

  public static setEnvironment(e: string) {
    Service.environment = e;
  }

  public static getEnvironment() {
    return Service.environment;
  }

  public static setCommunity(cid:string) {
    Service.community = cid;
  }

  public static getCommunity():string {
    return Service.community;
  }

  protected listeners:any[];

  constructor() {
    this.listeners = [];
  }

  public async init(): Promise<ServiceResponse> {
    return new Promise((resolve)=>{
      resolve({success: true});
    })
  }

  public async sync(): Promise<ServiceResponse> {
    return new Promise((resolve)=>{
      resolve({success: true});
    })
  }

  protected async sendCommand(method:string, command:string, params:any = null) {
    let response = await this.postCommand(method, command, params);

    if(response.status == 500) {
      let refreshResponse = await Server.refreshServiceLogin();
      if(!refreshResponse.success)
        return response;
      response = await this.postCommand(method, command, params);
    }
   
    if(response.body && response.body.tracking) {
      let now = new Date().toISOString();

      let st = window.localStorage.getItem('ServiceTracking');
      let serviceTracking:any = st ? JSON.parse(st) : {start: now, wru: 0, rru: 0};

      serviceTracking.last = now;
      serviceTracking.wru += response.body.tracking.wru;
      serviceTracking.rru += response.body.tracking.rru;

      window.localStorage.setItem('ServiceTracking', JSON.stringify(serviceTracking));
    }
    
    return response;
  }

  protected postCommand(method:string, command:string, params:any = null): Promise<{status:number, body?:any}> {
    return new Promise((resolve, reject)=>{
      let endpoint = Service.environment == 'dev' ? ServerConfig.gatewayDev : ServerConfig.gatewayProd;

      var request = new XMLHttpRequest();
      request.open('POST', `https://${endpoint}/${method}`);
      request.setRequestHeader('Content-Type', 'application/json');

      if(Service.authorizationToken != '')
        request.setRequestHeader('Authorization', Service.authorizationToken);

      const hostname = window.location.hostname;
      if (hostname.endsWith('.localhost') || hostname === 'localhost') {
        const devSecret = process.env.REACT_APP_DEV_SECRET;
        request.setRequestHeader('x-dev-secret', devSecret);
      }

      if(method == 'public') 
        request.setRequestHeader('x-api-key', 'rP0nNjJWdA4xH2ESdD3sM4cNoU76hDJvMdjr4uze');
  
      let payload:any = {command};

      if(params) 
        payload = {command, ...params};

      if(Service.community != '')
        payload.community = Service.community;

      let body = JSON.stringify(payload);

      let isProduction = !hostname.includes('localhost');
      if(!isProduction)
        console.log('==>', JSON.parse(body));

      request.send(body);
  
      request.onload = () => {
        let body = null;
        if (request.responseText != '')
          body = JSON.parse(request.responseText);

        if(!isProduction)
          if(body)
            console.log('<==', JSON.parse(request.responseText));
          else
            console.log('<== ' + request.status + ' ' + request.responseText);
  
        resolve({
          status: request.status,
          body: body
        });
      };
  
      request.onerror = (e) => {
        console.log('<== ERROR');
        resolve({
          status: 500,
          body: {message: 'Internal service error!'}
        });
      };
    });
  }

  public addEventListener(id:string, callback:Function) {
    this.listeners.push({id, callback});
  }

  public removeEventListener(id:string, callback:Function) {
    for(let i = 0; i < this.listeners.length; i++) {
      if(this.listeners[i].id == id && this.listeners[i].callback == callback) {
        this.listeners.splice(i, 1);
        return;
      }
    }
  }

  public notifyListeners(eventId:string, eventData:any = {}) {
    for(let i = 0; i < this.listeners.length; i++) 
      if(this.listeners[i].id == eventId) 
        this.listeners[i].callback(eventData);
  }

  public async sleep(duration:number): Promise<ServiceResponse> {
    return new Promise((resolve)=>{
      setTimeout(() => {
        resolve({success: true});
      }, duration);
    })
  }
}
